import { DateTime, IANAZone } from 'luxon';
import { timeZones } from './time-zones';

/**
 * Calculates the time difference in minutes between the provided time zone and the local time zone.
 *
 * @param timeZone - The IANA time zone name to compare with the local time zone.
 * @returns The time difference in minutes. Positive if the provided time zone is ahead of the local time zone, negative if behind.
 */
export function getMinuteTimeDifference(timeZone: string): number {
    if (!IANAZone.isValidZone(timeZone)) {
        throw new Error(`Invalid IANA time zone: ${timeZone}`);
    }
    const now = DateTime.now();
    const timeInZoneA = now.setZone(timeZone);
    const timeInZoneB = now.setZone(DateTime.local().zoneName);
    return timeInZoneA.offset - timeInZoneB.offset;
}

/**
 * Calculates the time difference in hours between the provided time zone and the local time zone.
 *
 * @param timeZone - The IANA time zone name to compare with the local time zone.
 * @returns A string representing the time difference in hours.
 *          Positive values are prefixed with "+", negative values with a "-"
 */
export function getHoursTimeDifferenceString(timeZone: string): string {
    const differenceInHours = getMinuteTimeDifference(timeZone) / 60;
    return differenceInHours < 0 ? differenceInHours.toString() : `+${differenceInHours}`;
}

/**
 * Returns a copy of the available IANA time zones.
 */
export function getTimeZones(): string[] {
    return [...timeZones]
}
